module.exports = "https://img.zhijierongxing.com/saas/img/close_icon.334241cb.png";